import instance from "@/services/api";

export const workSetCheckGroupsAPI = {
  async getList() {
    return await instance()
      .get("/common/work_set_check_groups/read/")
      .then((res) => res?.data);
  },

  async add(body) {
    return await instance()
      .post("/common/work_set_check_groups/upd/", body, {})
      .then((res) => res?.data);
  },

  async update(id, body) {
    return await instance()
      .post(`/common/work_set_check_groups/upd/`, {
        ...body,
        work_set_check_group_id: id,
      })
      .then((res) => res?.data);
  },

  async delete(id) {
    return await instance()
      .delete(`/common/work_set_check_groups/delete/work_set_check_group_id/${id}/` )
      .then((res) => res?.data);
  },

  async getCompanies() {
    return await instance()
      .get("/common/companies/read_fs/")
      .then((res) => res?.data);
  },
  async getStages() {
    return await instance()
      .get("/common/stages/read_fs/")
      .then((res) => res?.data);d
  },
};
